// Ported from monorepo corpus/page.tsx — the three-card front: what the
// corpus is, how the challenge score works, what is eligible. Content
// preserved; skin is the catalog treatment.
import { Link } from "react-router";
import { BookOpen, Library, Search } from "lucide-react";
import { Button } from "@bindery/ui/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@bindery/ui/components/ui/card";

export function LandingPage() {
  return (
    <main className="mx-auto max-w-4xl px-4 py-12">
      <div className="mb-12 text-center">
        <p className="catalog-label mb-3">sara.ai · reading corpus</p>
        <h1 className="font-serif text-5xl font-bold tracking-tight">Corpus</h1>
        <p className="text-muted-foreground mt-3 font-serif text-lg">
          Content database, recommender, and reading server
        </p>
        <p className="text-muted-foreground mx-auto mt-3 max-w-xl text-sm">
          Recommendations match every reader with texts they can actually read,
          based on their sight vocabulary.
        </p>
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <div className="bg-accent mb-2 w-fit rounded-lg p-2">
              <Search className="text-accent-foreground h-5 w-5" />
            </div>
            <CardTitle className="font-serif text-base">
              Recommendations
            </CardTitle>
            <CardDescription>
              Personalized reading suggestions based on your vocabulary profile.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild className="w-full">
              <Link to="/recommend">View recommendations</Link>
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="bg-accent mb-2 w-fit rounded-lg p-2">
              <BookOpen className="text-accent-foreground h-5 w-5" />
            </div>
            <CardTitle className="font-serif text-base">
              Reading Challenge
            </CardTitle>
            <CardDescription>
              Texts are scored by how close they are to 90% vocabulary
              familiarity — the optimal challenge level.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-xs">
              Score peaks at 90% known words. Too easy or too hard lowers the
              score.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="bg-accent mb-2 w-fit rounded-lg p-2">
              <Library className="text-accent-foreground h-5 w-5" />
            </div>
            <CardTitle className="font-serif text-base">Publications</CardTitle>
            <CardDescription>
              Curated collections from the 500 Books and Poetry series.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-xs">
              Only curated publications are eligible for EAR study
              recommendations.
            </p>
          </CardContent>
        </Card>
      </div>
    </main>
  );
}
